import axios from "axios";

const serviceModuel = {
    namespaced: true,
    state() {
        return {
            service: null,
            services: [],
            serviceCategories: [],
            serviceLoading: false,
            servicesLoading: false,
            serviceCategoriesLoading: false,
            pagination: null,
        };
    },
    mutations: {
        SET_SERVICES(state, data) {
            state.services = data;
        },
        SET_SERVICE_CATEGORIES(state, data) {
            state.serviceCategories = data;
        },
        SET_SERVICES_LOADING(state, loading) {
            state.servicesLoading = loading;
        },
        SET_SERVICE_CATEGORIES_LOADING(state, loading) {
            state.serviceCategoriesLoading = loading;
        },
        SET_PAGINATION(state, pagination) {
            state.pagination = pagination;
        },
        SET_SERVICE_LOADING(state, loading) {
            state.serviceLoading = loading;
        },
        SET_SERVICE_DATA(state, data) {
            state.service = data;
        }
    },
    actions: {
        async fetchServices({ commit , state }, payload) {
            const { business_id, page_number, category_id, price_min, price_max ,isfeatured } = payload;

            const params = new URLSearchParams();
            if (page_number) params.append('page', page_number);
            if (category_id != null) params.append('category_id', category_id);
            if (price_min != null) params.append('price_min', price_min);
            if (price_max != null) params.append('price_max', price_max);
            if (isfeatured != null) params.append('isfeatured', isfeatured);

            const url = `/api/services/${business_id}?${params.toString()}`;

            try {
                commit('SET_SERVICES_LOADING', true);
                let response = await axios.get(url);
                commit('SET_SERVICES', response.data.data);
                commit('SET_PAGINATION', response.data);
            } catch (errors) {
                console.log(errors);
            } finally {
                commit('SET_SERVICES_LOADING', false);
            }
        },
        async fetchService({ commit }, slug) {
            try {
                commit('SET_SERVICE_LOADING', true);
                let response = await axios.get(`/api/service/${slug}`);
                commit('SET_SERVICE_DATA', response.data);
            } catch (error) {
                console.log(error);
            } finally {
                commit('SET_SERVICE_LOADING', false);
            }
        },
        async fetchServiceCategories({ commit }, id) {
            try {
                commit('SET_SERVICE_CATEGORIES_LOADING', true);
                let response = await axios.get(`/api/serviceCategory/${id}`);
                commit("SET_SERVICE_CATEGORIES", response.data);
            } catch (errors) {
                console.log(errors);
            } finally {
                commit('SET_SERVICE_CATEGORIES_LOADING', false);
            }
        },
    },
    getters: {
        getService: (state) => state.service,
        getServices: (state) => state.services,
        getServiceCategories: (state) => state.serviceCategories,
        getServiceLoading: (state) => state.serviceLoading,
        getServicesLoading: (state) => state.servicesLoading,
        getServiceCategoriesLoading: (state) => state.serviceCategoriesLoading,
        getPagination: (state) => state.pagination,
    },
};

export default serviceModuel;
